import * as angular from 'angular';

const hostPortFieldFormatterDirective = function () {
  return {
    link: function (scope: angular.IScope) {
      const portField = scope.dataSourceForm['data_source[port]'];

      if (portField) {
        // Don't enable formatter if there's no port field
        scope.$watch('dataSource.host', function (newValue: string, _oldValue: string) {
          if (angular.isDefined(newValue) && newValue !== null) {
            const parts = newValue.split(/:(?=\d+$)/);
            if (parts.length === 2 && parts[1].length > 0) {
              scope.dataSource.host = parts[0];
              scope.dataSource.port = parseInt(parts[1], 10);
              portField.$$element.focus();
            }
          }
        });
      }
    },
  };
};

angular.module('mode.components').directive('hostPortFieldFormatter', hostPortFieldFormatterDirective);
